import { v4 as uuid } from "uuid"

export class RequestModel {
  data: string
  iscompressed: boolean
  correlationid: string

  constructor(data: string, iscompressed: boolean, correlationid: string = "") {
    this.data = data
    this.iscompressed = iscompressed
    this.correlationid = correlationid !== "" ? correlationid : uuid()
  }
}
